module.exports = __webpack_public_path__ + "img/blue_007.fbdde02b.png";